import { useDrag, useDrop } from 'react-dnd';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import _ from 'lodash';

import { Icon } from 'semantic-ui-react';
import { TagListFromTagHighlights } from '@playbookux/playbook-web-core';
import { dragDropTypes } from '../../../../../constants/drag-drop-types';
import { textEllipse } from '../../../../../../core/utils/text-format-helper';

import {
  ClipBottomFooter,
  ClipBottomHeader,
  ClipBottomLink,
  ClipBottomNote,
  ClipBottomTitle,
  ContainerClipBottom,
  IconClose,
  CARD_WIDTH,
  ContainerTag,
  IconTagHover,
  PopupTag,
  NumberTags,
  ContainerMaxHeight,
} from './style';

const MAX_USERNAME_LENGTH = 9;

const ClipBottom = (props) => {
  const {
    title,
    note,
    user,
    time,
    onRemoveClip,
    index,
    onClickPlay,
    id,
    tagHighlights,
    isPlaying,
  } = props;

  const [isOverHalf, setOverHalf] = useState(false);

  const ref = useRef(null);

  const username = textEllipse(user, MAX_USERNAME_LENGTH);

  const [{ isOver }, drop] = useDrop({
    accept: [dragDropTypes.CLIP_BOTTOM, dragDropTypes.CARD_CLIP],
    drop: () => ({ index }),
    hover(item, monitor) {
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get horizontal middle
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the left
      const hoverClientX = clientOffset.x - hoverBoundingRect.left;
      // Determine if we are showing a preview of the card
      const isShowingPreview = hoverBoundingRect.width > CARD_WIDTH;

      setOverHalf(isShowingPreview && hoverClientX > hoverMiddleX);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: dragDropTypes.CLIP_BOTTOM, title, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <div ref={ref}>
      <ContainerClipBottom
        isOver={isOver}
        isDragging={isDragging}
        isOverHalf={isOverHalf}
        isPlaying={isPlaying}
      >
        <ClipBottomHeader>
          <ClipBottomTitle>
            {title}
          </ClipBottomTitle>
          <IconClose
            name="close"
            onClick={() => onRemoveClip(index)}
          />
        </ClipBottomHeader>

        <ClipBottomNote>
          {note}
        </ClipBottomNote>

        <ClipBottomFooter>

          <div>
            {!_.isEmpty(tagHighlights) && (
              <PopupTag
                hoverable
                content={
                  (
                    <ContainerMaxHeight>
                      <TagListFromTagHighlights
                        tagHighlights={tagHighlights}
                      />
                    </ContainerMaxHeight>
                  )
                }
                trigger={(
                  <ContainerTag>
                    <NumberTags>
                      {!_.isEmpty(tagHighlights) ? tagHighlights.length : 0}
                    </NumberTags>
                    <IconTagHover src="/images/icon_show_tag.png" />
                  </ContainerTag>
                )}
              />
            )}
          </div>

          <ClipBottomLink onClick={() => onClickPlay(id)}>
            {`${username} ${time}`}
            <Icon name="play" />

          </ClipBottomLink>
        </ClipBottomFooter>
      </ContainerClipBottom>
    </div>
  );
};

ClipBottom.propTypes = {
  onRemoveClip: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  note: PropTypes.string.isRequired,
  user: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  onClickPlay: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  tagHighlights: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isPlaying: PropTypes.bool,
};

ClipBottom.defaultProps = {
  isPlaying: false,
};

export default ClipBottom;
